/**
 * 文档列表页面样式
 */

import { createStyles } from 'antd-style';
import  colorToken  from '../../utils/colorToken';

export const useDocumentListStyles = createStyles(({ token, css }) => ({
  container: css`
    padding: ${token.padding}px;
    background-color: var(--color-bg-container, ${colorToken.colorBgContainer});
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    height: 100vh;
  `,
  header: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${token.marginLG}px;
    
    @media (max-width: 768px) {
      flex-direction: column;
      gap: ${token.marginMD}px;
      align-items: stretch;
    }
  `,

  searchBar: css`
    max-width: 400px;
    
    @media (max-width: 768px) {
      max-width: 100%;
    }
  `,
  content: css`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  `,
  documentGrid: css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: ${token.marginMD}px;
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  `,
  pagination: css`
    text-align: center;
    margin-top: ${token.marginLG}px;
  `,
  emptyState: css`
    text-align: center;
    padding: ${token.paddingLG * 2}px;
    color: var(--color-text-secondary, ${colorToken.colorTextSecondary});
  `,
  loadingContainer: css`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
  `,
  filterBar: css`
    margin-bottom: ${token.marginMD}px;
    padding: ${token.padding}px;
    background-color: var(--color-bg-layout, ${colorToken.colorBgLayout});
    border-radius: ${token.borderRadius}px;
    border: 1px solid var(--color-border, ${colorToken.colorBorder});
  `,
  filterItem: css`
    margin-right: ${token.marginMD}px;
    
    &:last-child {
      margin-right: 0;
    }
  `,

  statsGrid: css`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: ${token.marginMD}px;
    margin-bottom: ${token.marginLG}px;
  `,
  statItem: css`
    text-align: center;
    padding: ${token.padding}px;
    background-color: var(--color-bg-container, ${colorToken.colorBgContainer});
    border-radius: ${token.borderRadius}px;
    border: 1px solid var(--color-border, ${colorToken.colorBorder});
  `,
  statNumber: css`
    font-size: ${token.fontSizeHeading2}px;
    font-weight: ${token.fontWeightStrong};
    color: var(--color-primary, ${colorToken.colorPrimary});
    margin-bottom: ${token.marginXS}px;
  `,
  statLabel: css`
    font-size: ${token.fontSizeSM}px;
    color: var(--color-text-secondary, ${colorToken.colorTextSecondary});
  `,
  tableContainer: css`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    
    .ant-card {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    
    .ant-card-body {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
      padding: 0;
    }
    
    .ant-table-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }
    
    .ant-table {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }
    
    .ant-table-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }
    
    .ant-table-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }
    
    .ant-table-tbody {
      flex: 1;
      min-height: 0;
    }
  `,
}));
